module.exports = __webpack_public_path__ + "static/img/ikonaTablice-OFF.7ee82d96.png";